<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="terminal-status-header">
    <div class="top-actions" *ngIf="showHeader">

        <div class="terminal-details" *ngIf="showHeader">
            <label class="data-na" *ngIf="tab.subTypeDetail[tab.subType.toLowerCase()]?.status !== 'loaded' || !summary"> NA </label>
            <label *ngIf="tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && summary" title="{{summary?.city}} , {{summary?.stateCode}} ({{summary?.milepost}})">{{summary && summary.city ? summary.city : '-'}} , {{summary && summary.stateCode ? summary.stateCode : '-'}} ({{summary && summary.milepost ? summary.milepost : '-'}})</label>
            <div *ngIf="tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && summary">
                <!-- <p title="{{summary && summary.divisionName ? summary.divisionName : '-'}} {{summary && summary.subDivision ? summary.subDivision : '-'}}"><span>Div:</span> {{summary && summary.divisionName ? summary.divisionName : '-'}} <span>Subdiv:</span>{{summary && summary.subDivision ? summary.subDivision : '-'}}</p> -->
                <p title="{{summary && summary.oprZoneName ? summary.oprZoneName : '-'}} {{summary && summary.oprSubZoneName ? summary.oprSubZoneName : '-'}}"><span>OprZone:</span> {{summary && summary.oprZoneName ? summary.oprZoneName : '-'}} <br/><span>OprSubzone:</span> {{summary && summary.oprSubZoneName ? summary.oprSubZoneName : '-'}}</p>
                <!-- add tooltip on subdivision-->
            </div>
        </div>
    
        <lms-header-sub-types [subTypes]="subTypes" [tab]="tab" [tabIndex]='tabLevel'></lms-header-sub-types>
    
        <div class="hours-spinner">
            <i class="fa fa-clock-o"></i>
            <p-dropdown styleClass="spinner-values" [tabindex]='tabLevel + 10' [options]="spinnerConfigData.allValues" (onChange)="onChange($event.value,'spinnerVal')" [(ngModel)]="spinnerVal"></p-dropdown>
        </div>
    
        <div class="no-through-trains">
            <p-checkbox name="isActive" [tabindex]='tabLevel + 12' binary="true" (onChange)="onChange($event?.checked,'noThroughTrains')" label="No Thru Trains" [(ngModel)]="noThroughTrains"></p-checkbox>
        </div>
    
        <div class="top-buttons-group terminal-status-header">
            <button class="p-button-secondary" [ngClass]="{'p-button-disabled': (!locosSelected || (user && !user.isUserManagerOrDirector))}" [disabled]="(!locosSelected || (user && !user.isUserManagerOrDirector))" tabindex="{{tabLevel + 15}}" (click)="openPlanLocoPopup()" title="Plan">
                <span class=" lms-ico lms-ico-plan"></span>
            </button>
    
            <!-- <button class="p-button-secondary " [ngClass]="{ 'p-button-disabled': !trainSelected} " [disabled]="!trainSelected
          " tabindex="{{tabLevel + 16}} " (click)="openTrainPopup( 'cancel') ">
            <span class="fa fa-ban "></span> Cancel Train
            </button>
    
            <button class="p-button-secondary " [ngClass]="{ 'p-button-disabled': !trainSelected} " [disabled]="!trainSelected
          " tabindex="{{tabLevel + 17}} " (click)="openTrainPopup( 'complete') ">
              <span class="fa fa-check-circle-o "></span> Complete Train
              </button> -->
    
            <button class="p-button-secondary " [ngClass]="{ 'p-button-disabled': !enablePendingList} " [disabled]="!enablePendingList
              " (click)="submitPendingAction()" tabindex="{{tabLevel + 18}}"title="Submit"> 
              <span class=" lms-ico lms-ico-submit"></span>
            </button>
        
            <button class="p-button-secondary" [ngClass]="{ 'p-button-disabled': !trainSelected && !locosSelected} " [disabled]="!trainSelected && !locosSelected
          " (click)="clearAllSelection()" tabindex="{{tabLevel + 19}}" title="Clear Selection"> 
                <!-- Clear Selection -->
                <span class="lms-ico lms-ico-clear-selection" aria-hidden="true"></span>
            </button>
    
            <button class="p-button-secondary" [ngClass]="{ 'p-button-disabled': !trainSelected} " [disabled]="!trainSelected
                " tabindex="{{tabLevel + 17}} " (click)="openTrainPopup( 'complete') " title="Complete Train"> 
            <span class=" lms-ico lms-ico-complete-train"></span> 
            </button>
    
            <button class="p-button-secondary" [ngClass]="{ 'p-button-disabled': !trainSelected} " [disabled]="!trainSelected
            " tabindex="{{tabLevel + 16}} " (click)="openTrainPopup( 'cancel') " title="Cancel Train">
              <span class="lms-ico lms-ico-cancel-train"></span> 
            </button>
    
            <button class="p-button-secondary" 
            [ngClass]="{ 'p-button-disabled': !locosSelected || !totalCancellableLocos || (totalCancellableLocos && totalCancellableLocos === 0)
            || (user && !user.isUserManagerOrDirector) } " 
            [disabled]="!locosSelected || !totalCancellableLocos || (totalCancellableLocos && totalCancellableLocos === 0)
            || (user && !user.isUserManagerOrDirector)" 
            (click)="cancelAllLocomotives()" tabindex="{{tabLevel + 20}}" title="Cancel Locomotive Plan">
                <span class=" lms-ico lms-ico-cancel-loco"></span>
            </button>
            <!-- <p-menu #menu [popup]="true" [model]="otherOptions" ></p-menu>
            <button  class="p-button-secondary  lms-ico lms-ico-overflow" type="button" pButton (click)="menu.toggle($event)" [disabled]="user && !user.isUserManagerOrDirector">
                <span class="lms-ico lms-ico-overflow"></span> 
            </button>     -->
    
            <button class="p-button-secondary" 
            [ngClass]="{ 'p-button-disabled': !locosSelected || (user && !user.isUserManagerOrDirector) || !allocateRole || (allocateRole && (allocateRole.toUpperCase().trim() !== 'YL' && allocateRole.toUpperCase().trim() !== 'MW'))} " 
            [disabled]="!locosSelected || (user && !user.isUserManagerOrDirector) || !allocateRole || (allocateRole && (allocateRole.toUpperCase().trim() !== 'YL' && allocateRole.toUpperCase().trim() !== 'MW'))
            " tabindex="{{tabLevel + 16}} " (click)="otherActionTaken('allocate')" title="Allocate">
              <span class="lms-ico lms-ico-allocate"></span> 
            </button>
    
            <button class="p-button-secondary" 
            [ngClass]="{ 'p-button-disabled': !locosSelected || (user && !user.isUserManagerOrDirector) || !allocateRole || (allocateRole && (allocateRole.toUpperCase().trim() !== 'YL' && allocateRole.toUpperCase().trim() !== 'MW'))} " 
            [disabled]="!locosSelected || (user && !user.isUserManagerOrDirector) || !allocateRole || (allocateRole && (allocateRole.toUpperCase().trim() !== 'YL' && allocateRole.toUpperCase().trim() !== 'MW'))
            " tabindex="{{tabLevel + 16}} " (click)="otherActionTaken('deallocate')" title="Deallocate">
              <span class="lms-ico lms-ico-deallocate"></span> 
            </button>
    
        </div>

        <div class="pending-action" *ngIf="tab.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'">
            <a (click)="showPendingList = !showPendingList" class="pending-action-inheader"> <i class="fa fa-exclamation-triangle "></i> <span>Pending Actions ({{pendingActionsLength}})</span></a>
            <p class="color-red pending-action-label">Pending Actions ({{pendingActionsLength}})</p>
            <div class="pending-action-overlay" [hidden]="!showPendingList">
                <div class="p-overlaypanel">
                    <lms-terminal-pending-actions [lmsExceptionList]="lmsExceptionList" [allStatusdata]="allStatusdata" (submitPendingAction)="submitPendingAction($event)"></lms-terminal-pending-actions>
                </div>
            </div>
        </div>
    
        <!--START Bre Exception Notification Popup -->
        <p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="true" class="terminal-ui-popups submit-error-dialog" header="Submit Error" [(visible)]="ruleExceptionInfoPopup" modal="true" closeOnEscape="true" (onShow)='updateEnterButtonFocus("ruleExcpSbmtBtn");' (onHide)='updateEnterButtonFocus("")'>
            <div class="dialog-container exception-dialog">
                <div class="exception-reason text-center">
                    <div class="exception-details">
                        <span class="color-red"><strong> Problem with {{(lmsExceptionList && lmsExceptionList.length > 1) ? lmsExceptionList.length : '' }} Planned {{(lmsExceptionList
                && lmsExceptionList.length > 1) ? 'Locomotives' : 'Locomotive' }} </strong> </span>
                        <p class="info-text">Check Pending Action panel</p>
                        <br>
                        <p class="info-text">To <strong class="color-black"><b> Override Rule, </b> </strong> Select Loco and hit "Submit Pending".</p>
                        <p class="info-text">Unselected Loco will be auto cancelled.</p>
                    </div>
                </div>
            </div>
            <div class="dialog-buttons">
                <span class="pull-right">
                                    <!--<button type="button" class="p-button-secondary" (click)='cancelRuleExceptionInfoPopup();'>No</button>-->
                                    <button type="button" id="ruleExcpSbmtBtn" class="p-button-primary" (click)='submitRuleExceptionInfoPopup();'>OK</button>
                                </span>
            </div>
        </p-dialog>
        <!-- END Bre Exception Notification Popup -->
    
        <p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="true" class="terminal-ui-popups confirmation-dialog standard-dialog" header="Confirmation" [(visible)]="showWarnPop" (onShow)='updateEnterButtonFocus("warnPopSbmtBtn");' (onHide)="hideWarnPopup()" modal="true">
            <div class="generic-spacing">
                {{warnMessage}}
            </div>
    
            <div class="dialog-buttons">
    
                <span class="pull-right">
                    <button class="p-button-secondary" (click)="hideWarnPopup()">No</button>
                        <button id="warnPopSbmtBtn" class="p-button-primary" (click)="goToRefresh()">Yes</button>
                </span>
    
            </div>
        </p-dialog>
    
    </div>
</div>